import React from 'react'
import PropTypes from 'prop-types'
import {updateTenantRouting} from "../../../../../../services/api/apiCustomerHub";
import parseToken from "../../../../../../helpers/parseToken";
import {message, Popconfirm} from "antd";
import checkRole from "../../../../../../helpers/checkRole";
import RoutingAdd from "./RoutingAdd";

RoutingBlock.propTypes = {
    custId: PropTypes.string
}

function RoutingBlock(props) {
    const {custId, tenantFullName, fetchTenantRouting, listTelco, listRoutingBlock} = props
    const isEdit = checkRole('menu.customerhub.editRouting')
    const decodeToken = parseToken()

    const mapTelcoCode = (code) => {
        const itemTelco = listTelco.find(item => item.code === code)
        if (itemTelco !== undefined) return itemTelco.name
        return ''
    }

    const handleDelete = async (id) => {
        try {
            const payload = {
                id,
                status: 0
            }
            const response = await updateTenantRouting(decodeToken.sub, payload)

            const {success, error_message} = response
            if (parseInt(success) !== 1) {
                return message.error(error_message)
            }
            message.success('Xóa thành công!')
            fetchTenantRouting()
        } catch (e) {
            message.error(e.message)
        }
    }

    return (
        <div className="BlockCenter">
            <div className="headerBlock d-flex align-items-start justify-content-between">
                <h3>Định tuyến</h3>
            </div>
            <div className="ContentPage">
                <div className="CustomersTable">
                    <table>
                        <thead className="CustomersHead">
                        <tr>
                            <th>Chủ gọi</th>
                            <th>Bị gọi</th>
                            <th>Ưu tiên</th>
                            <th className="Actions"/>
                        </tr>
                        </thead>
                        <tbody className="CustomersBody">
                        {
                            listRoutingBlock.length > 0 && listRoutingBlock.map(item => {
                                return (
                                    <tr className="CustomersItem">
                                        <td>{mapTelcoCode(item?.callerPrefix)}</td>
                                        <td>{mapTelcoCode(item?.calledPrefix)}</td>
                                        <td>{item?.priority}</td>
                                        <td align="right">
                                            {isEdit && (
                                                <Popconfirm placement="top" title="Bạn chắc chắn muốn xóa?"
                                                            onConfirm={() => handleDelete(item?.id)} okText="Yes"
                                                            cancelText="No">
                                                    <span
                                                        className="material-icons cursor-pointer text-danger">delete</span>
                                                </Popconfirm>
                                            )}
                                        </td>
                                    </tr>
                                )
                            })
                        }
                        </tbody>
                        {isEdit && (
                            <tfoot className="CustomersBody">
                            <tr className="CustomersItem">
                                <td colSpan={3}/>
                                <td className="Actions" align="right">
                                    <RoutingAdd
                                        custId={custId}
                                        listTelco={listTelco}
                                        fetchTenantRouting={fetchTenantRouting}
                                        tenantFullName={tenantFullName}
                                    />
                                </td>
                            </tr>
                            </tfoot>
                        )}
                    </table>
                </div>
            </div>
        </div>
    )
}

export default RoutingBlock
